import React, { useEffect, useRef, useState } from 'react';
import Authentication from '../../../../../libs/api/services/Authentication';
import WorkFlow from '../../../../../libs/api/services/WorkFlow';
import './PatientEventType.css';

export default function PatientEventTypeWorkFlow({ defaultValue, onChanged, placeholder, fieldId, optionsId }) {
    const inputRef = useRef(null);
    const [options, setOptions] = useState([])
    const [search, setSearch] = useState([])
    const [filter, setSFilter] = useState('')
    const [option, setOption] = useState(placeholder || 'Event')
    const [show, setShow] = useState(false)
    const [showAddNew, setShowAddNew] = useState(false)
    const [selectedGroupId, setSelectedGroupId] = useState('')
    const [newGroupName, setNewGroupName] = useState('')
    const [newEventName, setNewEventName] = useState('')
    const [creating, setCreating] = useState(false)
    const [createError, setCreateError] = useState('')

    useEffect(() => {
        if (show && inputRef.current) {
            inputRef.current.focus();
        }
    }, [show])

    useEffect(() => {
        if (!show) {
            setShowAddNew(false)
            setSelectedGroupId('')
            setNewGroupName('')
            setNewEventName('')
            setCreateError('')
            setCreating(false)
        }
    }, [show])

    const LoadWorkFlowEvents = async () => {
        var _res = []
        const Groups = await WorkFlow.ListGroups(Authentication.getFacility())
        for (const Group of Groups)
            _res.push({
                group: Group,
                events: await WorkFlow.ListCategoryEvents(Group.id)
            })
        setOptions(_res)
        setSearch(_res)
    }

    useEffect(() => {
        LoadWorkFlowEvents()
    }, [])

    useEffect(() => {
        if (!defaultValue || options.length === 0) return

        for (const category of options) {
            const matchedEvent = category.events.find((ev) => ev.id === defaultValue)
            if (matchedEvent) {
                setOption(matchedEvent.name)
                return
            }
        }
    }, [defaultValue, options])

    const _handleOptionSelected = (option) => {
        setOption(option.name)
        onChanged(option.id)
        setShow(false)
        setSearch(options)
        // setSearch([])
        setSFilter('')
    }
    const _removeTrailing = (word) => {
        const verbEndings = ['ed', 'ing', '\'s', 'es', 'ie']
        for (var e of verbEndings) {
            if (word.substr(word.length - e.length) === e) {
                word = word.substr(0, word.length - e.length)
            }
        }
        return word
    }
    const _handleSearch = (_filter) => {
        setSFilter(_filter)
        var _result = []
        for (var category of options) {
            var _rlist = []
            for (var event of category.events) {
                var _score = 0;
                var _score_search_length = event.name.length;
                // split words
                for (var wordSearch of _filter.toLowerCase().split(' ')) {
                    //  remove ed,ing, er est ile able 
                    for (var resultSearch of event.name.toLowerCase().split(' ')) {
                        if (_removeTrailing(resultSearch).includes(_removeTrailing(wordSearch))) {
                            _score++;
                        }
                    }
                }
                var final_score = _score === 0 ? 0 : _score_search_length / _score

                if (final_score > 0.7) {
                    _rlist.push({
                        id: event,
                        event: event.name,
                        score: _score
                    })
                }
            }
            if (_rlist.length > 0)
                _result.push({
                    id: category.id,
                    // category: category.category,
                    group: category.group,
                    events: _rlist
                })
        }
        var _result_sorted = []
        for (var r of _result) {
            var _result_sorted_events = []
            for (var e of r.events.sort((b, a) => parseFloat(a.score) - parseFloat(b.score))) {
                _result_sorted_events.push({
                    id: e.id.id,
                    name: e.event
                })
            }
            _result_sorted.push({
                id: r.id,
                group: r.group,
                //category: r.category,
                // events: []
                events: _result_sorted_events
            })
        }
        setSearch(_result_sorted)
    }

    const _handleCreateWorkflowEvent = async () => {
        setCreateError('')

        const eventName = (newEventName || '').trim()
        if (eventName === '') {
            setCreateError('Event name is required')
            return
        }

        let groupId = selectedGroupId
        if (groupId === '__new__') {
            const groupName = (newGroupName || '').trim()
            if (groupName === '') {
                setCreateError('Group name is required')
                return
            }

            try {
                setCreating(true)
                const createdGroup = await WorkFlow.UpdateGroup({
                    name: groupName,
                    facility: Authentication.getFacility() ? { id: Authentication.getFacility() } : undefined,
                })
                groupId = createdGroup.id
            } catch (e) {
                setCreateError('Unable to create group')
                setCreating(false)
                return
            }
        }

        if (!groupId) {
            setCreateError('Select a group or create a new one')
            return
        }

        try {
            setCreating(true)
            const createdEvent = await WorkFlow.UpdateEvent({
                group: { id: groupId },
                name: eventName,
            })

            await LoadWorkFlowEvents()
            _handleOptionSelected(createdEvent)
            setShowAddNew(false)
            setSelectedGroupId('')
            setNewGroupName('')
            setNewEventName('')
            setCreateError('')
        } catch (e) {
            setCreateError('Unable to create event')
        } finally {
            setCreating(false)
        }
    }

    return (
        <div style={{ zIndex: 99 }} className='position-relative single-selection'>
            <div onClick={(e) => setShow(!show)} className='form-control selected-option ' >{option}</div>
            <div className={'bg-secondary p-3 rounded position-absolute w-100 options-container '.concat(show ? 'd-block' : 'd-none')}>
                <input
                    ref={inputRef}
                    value={filter}
                    onChange={(e) => _handleSearch(e.target.value)}
                    className='form-control single-option-search '
                    placeholder={placeholder || 'Search'}
                />
                <div className='d-flex justify-content-end mt-2'>
                    <button
                        type='button'
                        onClick={() => {
                            setShowAddNew(!showAddNew)
                            setCreateError('')
                        }}
                        className='btn btn-sm btn-light'
                    >
                        {showAddNew ? 'Close add new' : 'Add new event'}
                    </button>
                </div>

                {showAddNew && (
                    <div className='mt-2 p-2 rounded bg-dark'>
                        <label className='small mb-1 d-block'>Choose group</label>
                        <select
                            value={selectedGroupId}
                            onChange={(e) => setSelectedGroupId(e.target.value)}
                            className='form-control form-control-sm'
                        >
                            <option value=''>Select group</option>
                            {options.map((item) => (
                                <option key={item.group.id} value={item.group.id}>{item.group.name}</option>
                            ))}
                            <option value='__new__'>+ Create new group</option>
                        </select>

                        {selectedGroupId === '__new__' && (
                            <>
                                <label className='small mb-1 mt-2 d-block'>New group name</label>
                                <input
                                    value={newGroupName}
                                    onChange={(e) => setNewGroupName(e.target.value)}
                                    className='form-control form-control-sm'
                                    placeholder='Group name'
                                />
                            </>
                        )}

                        <label className='small mb-1 mt-2 d-block'>Event name</label>
                        <input
                            value={newEventName}
                            onChange={(e) => setNewEventName(e.target.value)}
                            className='form-control form-control-sm'
                            placeholder='Event name'
                        />

                        {createError && <div className='text-warning small mt-2'>{createError}</div>}

                        <div className='d-flex justify-content-end mt-2'>
                            <button
                                type='button'
                                disabled={creating}
                                onClick={_handleCreateWorkflowEvent}
                                className='btn btn-sm btn-light'
                            >
                                {creating ? 'Creating...' : 'Create and select'}
                            </button>
                        </div>
                    </div>
                )}

                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                    {
                        search.map((event) =>
                            <React.Fragment key={event.group.id}>
                                <div
                                    value={event.group.name}
                                    // onClick={() => _handleOptionSelected(event.category)}
                                    className={'category'}
                                >{event.group.name}</div>
                                {
                                    event.events.map((ev) =>
                                        <div
                                            key={ev.id} value={ev.name}
                                            onClick={() => _handleOptionSelected(ev)}
                                            className={option === ev.name ? 'options selected' : 'options'}
                                        >{ev.name}
                                        </div>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </div>
            </div>
        </div>
    )
}
